// A read that did not come back, drawn the design's way (TASKS §143, step 5).
//
// The prototype keeps the page's head on screen and puts the failure where
// the content would have been: the kit's Failed card, with "Ask again". This
// console used to replace the whole page with Refusal.tsx instead, a heading
// of its own and no way to retry. Gabe chose the design's (9 Oct).
//
// What Refusal.tsx carried that the design does not draw is kept, because it
// is behaviour rather than layout: the title for each kind of failure, the
// server's own sentence, the way out for an admin refused for want of an
// authenticator, and the line that says nothing below was counted. A session
// that has ended is not offered a retry; the app is already taking the reader
// to sign in.

import type { ReactNode } from "react";
import { Failed } from "@nova/desk-ui/states";
import type { Failure } from "../api/client.js";
import { titleFor } from "./Refusal.js";

export type ReadFailedProps = {
  /** What did not load, as a heading: "Could not load the consent report". */
  readonly what: string;
  readonly failure: Failure;
  readonly role: string;
  readonly onEnrol: () => void;
  /** What is therefore not shown, said rather than left as an empty page. */
  readonly notCounted: string;
  readonly onRetry: () => void;
};

export function ReadFailed({ what, failure, role, onEnrol, notCounted, onRetry }: ReadFailedProps): ReactNode {
  return (
    <>
      <Failed
        what={what}
        detail={`${titleFor(failure)}. ${failure.detail}`}
        onRetry={failure.kind === "session_ended" ? undefined : onRetry}
      />
      {failure.kind === "refused" && role === "nova_admin" ? (
        <div>
          <div className="acts">
            <button type="button" className="btn" onClick={onEnrol}>
              Set up an authenticator
            </button>
          </div>
          <p className="help help-tight">
            Nova admin reports need an authenticator. If yours is already set up, sign out and sign in again.
          </p>
        </div>
      ) : null}
      <p className="help help-tight">{notCounted}</p>
    </>
  );
}
